import React, {useEffect, useRef, useState} from 'react';
import {Container, Row, Col, Modal, Button} from 'react-bootstrap';
import 'react-slideshow-image/dist/styles.css';
import Slide1 from '../../assets/images/slide/Slide1.png';
import { BsArrowRight } from 'react-icons/bs';
import HCaptcha from "@hcaptcha/react-hcaptcha";
import validator from "validator";
import Swal from "sweetalert2";
import {Backdrop, CircularProgress} from "@mui/material";

const properties = {
    duration: 5000,
    transitionDuration: 500,
    infinite: true,
    indicators: true,
    arrows: false,
    pauseOnHover: true
};

const slideImages = [
    {
        url: Slide1,
        title: 'Custom Design Manufacturing',
        description: 'DSSL has extensive custom design experience that enables us to design and manufacture custom solutions for unique project needs.',
        button: 'REQUEST QUOTE NOW'
    },
];

const Slider = () => {
    const [isShowModal, setShowModal] = useState(false);

    const [email, setEmail] = useState("");
    const [isQuote, setQuote] = useState("");
    const [isEmailError, setIsEmailError] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [isCaptchaExpired, setIsCaptchaExpired] = useState(false);
    const [token, setToken] = useState(null);
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);
    const captchaRef = useRef(null);



    useEffect(() => {
        if (isCaptchaExpired) setToken(null);
    }, [isCaptchaExpired]);



    const handleVerificationSuccess = token => {
        setToken(token);
        if (token) setIsCaptchaExpired(false);
    };

    const handleEmailSend = () => {
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify({
                email: email,
                quote: isQuote
            })
        };

        setIsClicked(true);
        if (!validator.isEmail(email)) {
            setIsEmailError(true);
        } else {
            setIsEmailError(false);
        }

        if (validator.isEmail(email) && token) {
            setIsOpenBackdrop(true);
            fetch(`/api/quote/send`, requestOptions)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setIsClicked(false);
                    setEmail("");
                    setToken(null);
                    setQuote("");
                    setIsOpenBackdrop(false);
                    captchaRef.current.resetCaptcha();

                    if (result.status === "success") {
                        Swal.fire("Success!", result.msg, "success");
                    } else {
                        Swal.fire("Oops...", result.msg, "error");
                    }
                }).catch(err => console.log(err));
        }
    };

    return (
        <Container>
            {slideImages.map((slideImage, index) => (
                <Row className="each-slide" key={index}>
                    <Col md={6}>
                        <img src={slideImage.url} alt={index} height="500px" width="100%" />
                    </Col>
                    <Col md={6} className='slide-contents'>
                        <h1>{slideImage.title}</h1>
                        <p className='mt-3'>{slideImage.description}</p>
                        <span className='view-new-product-btn mt-3' onClick={() => setShowModal(true)}>{slideImage.button} <BsArrowRight style={{ marginLeft: "20px" }} /></span>
                    </Col>
                </Row>
            ))}
            <Modal
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={isShowModal}
                onHide={() => setShowModal(false)}
            >
                <Modal.Header closeButton>
                    <h5 className="modal-title" id="exampleModalLabel">
                        Specification
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    <form
                        className="form-floating mb-3"
                        id="form"
                        noValidate
                    >
                        <input
                            name="email"
                            type="email"
                            className={`form-control ${isEmailError
                                ? "is-invalid"
                                : isClicked && "is-valid"
                            }`}
                            id="floatingInput"
                            placeholder="name@gmail.com"
                            defaultValue={email}
                            onChange={e => {
                                setEmail(e.target.value);
                            }}
                        />
                        <label htmlFor="floatingInput">Email address</label>
                        {isEmailError ? (
                            <div className="invalid-feedback">
                                Please enter a valid email.
                            </div>
                        ) : (
                            isClicked && (
                                <div className="valid-feedback">
                                    Looks good!
                                </div>
                            )
                        )}
                        <textarea name='quote' className='mt-2' style={{ width: "100%", border: "1px solid #ced4da" }} value={isQuote} onChange={(e) => setQuote(e.target.value)} rows={4}></textarea>
                        <div className="mt-2">
                            <HCaptcha
                                ref={captchaRef}
                                sitekey="8d147cae-36a3-40e9-a9c5-6f5742ce5219"
                                onVerify={token =>
                                    handleVerificationSuccess(token)
                                }
                                onExpire={() => setIsCaptchaExpired(true)}
                            />
                        </div>
                        {!token && isClicked ? (
                            <p className="text-danger">
                                This is hCaptcha for human testing.
                            </p>
                        ) : (
                            isCaptchaExpired && (
                                <p className="text-danger">
                                    The hCaptcha for human testing has expired.
                                </p>
                            )
                        )}
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={() => setShowModal(false)}
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        id="closeModal"
                    >
                        Close
                    </Button>
                    <Button
                        onClick={() => handleEmailSend()}
                        type="submit"
                        className="btn btn-dark"
                    >
                        Send
                    </Button>
                </Modal.Footer>
            </Modal>
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: theme => theme.zIndex.drawer + 1
                }}
                open={isOpenBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Container>
    )
}

export default Slider;
